/** @module FormulatedProduct/FoodLabel/FoodLabelItemProductSalesRegionsMatrix */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/constants",
	"csi/core/Key",
	"csi/heading/Spec",
	"csi/table/matrix/Path",
	"csi/xml",
], function(
	declare,
	_,
	constants,
	Key,
	Spec,
	Path,
	xml
) {
	return declare(Path, {
		bAllowColumnFilter: true,
		columnPath: "Child:__Parent__/Child:__Parent__/Child:ProductSalesRegions",
		columnSortAttr: xml.ATTR_NAME,
		restrictQuery: true,
		selectedColumnValueProperty: "activeProductSalesRegions",
		selectedColumnValueDefaultsToAll: true,

		/**
		 * @override
		 * Add any dependency paths to the language applied to the sales regions
		 */
		addDependencyPaths: function(h, paths) {
			paths.push("Child:__Parent__/Child:__Parent__/Child:ProductSalesRegions/Child:ProductSalesRegionSpec/Child:SellingCountries/Child:Languages");
			this.inherited(arguments);
		},

		/**
		 * @override
		 * If SalesRegion selector is not empty, return only selected SalesRegion's
		 */
		_getColumnNodes: function(ctx, h) {
			let salesRegions = this.inherited(arguments);

			const selectedSalesRegionUrls = ctx.view.activeProductSalesRegions;
			if (!_.isEmpty(selectedSalesRegionUrls)) {
				const allUrls = _.pluck(salesRegions, "$URL");
				const urls = _.intersection(selectedSalesRegionUrls, allUrls);
				salesRegions = ctx.cache.getNodes(urls);
			}

			return salesRegions;
		},

		/**
		 * @override
		 * Add Language sub columns
		 */
		onPathSpecParams: function(ctx, params, columnIndex) {
			const salesRegionNode = ctx.getNode();

			if (!salesRegionNode) {
				return false;
			}

			const {cache} = ctx;
			const languages = _.uniq(cache.getPathNodes(salesRegionNode, "Child:ProductSalesRegionSpec/Child:SellingCountries/Child:Languages"));

			if (_.isEmpty(languages)) {
				return false;
			}

			// For each sales region, create sub-spec for each language
			const specs = [];

			ctx.forEach(languages, (ctx, i) => {
				const languageNode = ctx.getNode();
				const columnUrl = languageNode.$URL;
				const key = new Key({
					id: "Languages",
					path: "Child:LibraryItem",
				});

				const heading = ctx.view.getHeading(key);
				heading.bCopy = true;

				const spec = new Spec({
					css: constants.CSS_TABLE_COLUMNS,
					columnUrl,
					headerParams: {
						multiLineText: languageNode.$Name,
					},
					heading,
					index: languageNode.SysID,
				});

				// set query path to include index
				const querySpec = this._getColumnQuerySpec(ctx, spec);
				spec.setQuerySpec(querySpec);

				specs.push(spec);
			});

			params.subs = specs;
			params.headerParams.colSpan = specs.length;

			return true;
		},

		/**
		 * @override
		 */
		_getRowNodes: function(ctx, qr, c, node) {
			return [node];
		},

		/**
		 * @override
		 * Use Language's SysIDs to be the Spec indices
		 */
		_getSpecIndices: function(ctx, spec, nodes) {
			return [spec.index];
		},

		/**
		 * @override
		 * The incoming nodes is a FoodLabelItem for the row. Cell for invalid item will be hashed out :
		 *     The library item (e.g. FoodAllergen) Languages is not empty for that language SysId, or
		 *     Not valid for the currect ProductSalesRegion
		 */
		_getSpecNodes: function(ctx, spec, nodes) {
			const {cache, view} = ctx;
			const foodLabelItem = nodes[0];
			const libraryItemUrl = foodLabelItem && foodLabelItem.LibraryItem;
			const libraryItemNode = xml.isValidURL(libraryItemUrl) && cache.getNode(libraryItemUrl);

			// Hashed out the cell for special item
			if (!libraryItemNode) {
				return [];
			}

			// Hashed out if the FoodLabelItem is not applied to the ProductSalesRegion
			const onlyForSalesRegionUrls = foodLabelItem.OnlyForProductSalesRegions;
			const salesRegionUrl = spec.parentSpec.columnUrl;
			if (!_.isEmpty(onlyForSalesRegionUrls) && !_.contains(onlyForSalesRegionUrls, salesRegionUrl)) {
				return [];
			}
			return nodes;
		},

	});
});
